import * as React from "react";
import "./deletedilog.css";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useDispatch, useSelector } from "react-redux";
import axiosInstance from "../../axios";
import { getBlog } from "../../pages/afterAuth/blogMore/redux/actionCreater";
import { toast } from "react-toastify";
// import { deleteblogdata } from "../../pages/afterAuth/blogMore/redux/actionCreater";
export default function BlogDeleteDilog({
  isOpenDelete,
  setIsOpenDelete,
  idDelete,
}) {
  const { blogData } = useSelector((state) => state?.blog);
  const cardData = blogData?.bloginfo;
  const dispatch = useDispatch();
  // const [rows, setRows] = useState([]);
  const NoButtonStyle = {
    width: "38%",
    color: "#1A5AFA",
    border: "1.5px solid #1A5AFA",
    fontFamily: "Be Vietnam Pro",
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: "0.875rem",
  };
  const YesButtonStyle = {
    width: "38%",
    color: "#BF5649",
    border: "1.5px solid #BF5649",
    fontFamily: "Be Vietnam Pro",
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: "0.875rem",
    "&:hover": { border: "1.5px solid #BF5649" },
  };
  const handleClose = () => {
    setIsOpenDelete(false);
  };
  const handleDelete = async (id = "") => {
    try {
      const response = await axiosInstance.delete(`/blogs/${idDelete}`);
      console.log(response, "deleteddata");
      if (response?.status === 200) {
        dispatch(getBlog(response));
        toast.success("Successfully deleted ", {
          toastId: "deleteBlog-1",
        });
      }
    } catch (error) {
      console.log("Error deleting blogs", error);
    }
    setIsOpenDelete(false);
  };

  return (
    <div>
      <Dialog open={isOpenDelete} onClose={handleClose}>
        <DialogTitle
          sx={{ padding: "1.5rem 1.5rem 0.5rem 1.5rem" }}
          id="alert-dialog-title"
        >
          Remove Blog
        </DialogTitle>

        <DialogContent
          sx={{ width: "20rem", height: "auto", padding: "1rem 1.5rem" }}
        >
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to remove this?
          </DialogContentText>
        </DialogContent>

        <div className="dialogButton">
          <Button
            sx={YesButtonStyle}
            style={{ color: "#BF5649" }}
            variant="outlined"
            onClick={handleDelete}
          >
            Yes
          </Button>
          <Button sx={NoButtonStyle} variant="outlined" onClick={handleClose}>
            No
          </Button>
        </div>
      </Dialog>
    </div>
  );
}
